module.exports = __webpack_public_path__ + "img/ns_base.4eab1d12.jpg";